export const DISABLE_NAV = [
'/auth', '/get-started'
];
